import React from 'react';
import {
  EditButton as EmailEdit,
  Datagrid,
  Filter,
  List,
  Pagination,
  SearchInput,
  TextField,
} from 'react-admin';
import { Box } from '@material-ui/core';
import { EmailDuplicate } from '../../resources/emails';
import { makeStyles } from '@material-ui/core/styles';
import { authServer } from '../../auth/keycloak';

const useRowControlsStyles = makeStyles({
  row: {
    '& > td:last-of-type > div': {
      textAlign: 'right',
      opacity: 0,
    },
    '&:hover': {
      '& > td:last-of-type > div': {
        opacity: 1,
      },
    },
  },
});

const RowControls = ({ record, basePath }) => {
  return (
    <Box>
      {authServer.isRoles(['product']) && (
        <EmailDuplicate record={record} basePath={basePath} />
      )}
      <EmailEdit record={record} basePath={basePath} />
    </Box>
  );
};

const EmailListPagination = (props) => (
  <Pagination rowsPerPageOptions={[50, 100, 500]} {...props} />
);

export default ({ ...props }) => {
  const classes = useRowControlsStyles();
  return (
    <List
      {...props}
      exporter={false}
      bulkActionButtons={false}
      sort={{ field: 'name', order: 'ASC' }}
      perPage={50}
      pagination={<EmailListPagination />}
      filters={
        <Filter>
          <SearchInput
            placeholder="Search by email name"
            source="name_search"
            alwaysOn
          />
        </Filter>
      }
    >
      <Datagrid classes={{ row: classes.row }}>
        <TextField label="Template Name" source="name" sortable={false} />
        <TextField label="Language" source="language" sortable={false} />
        <RowControls {...props} />
      </Datagrid>
    </List>
  );
};
